module.exports = __webpack_public_path__ + "img/team.c6b59845.jpg";